import { createTheme } from "@mui/system";

const alacuentaTheme = createTheme({
  palette: {
    primary: {
      main: '#b41b64',
    },
    secondary: {
      main: '#eeeeee',
    },
  }
});

export default alacuentaTheme;
